import { isIPad, isIPhone } from '../../../../jira-common/utils/native/detectDeviceType';
export var getDropDownMenuPosition = function getDropDownMenuPosition() {
  return isIPhone() || isIPad() ?
  // This is to prevent menu floating away due to virtual keyboard in iPad and iPhone
  {
    menuPosition: 'absolute'
  } :
  // This is to prevent long menus getting cut off in portal
  {
    menuPosition: 'fixed'
  };
};